import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { closeDrawer } from '@/core/features/drawer';
import { inviteMemberRequest } from '@/api/members';
import i18n from '@/i18n';
import { inviteMember, fetchMembers } from '../actions';

const inviteMemberEpic: Epic = (action$) =>
  action$.pipe(
    filter(inviteMember.match),
    request(({ payload }) => inviteMemberRequest(payload), inviteMember),
  );

const inviteMemberSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(inviteMember.succeeded.match),
    mergeMap(
      ({
        payload: {
          originalData: { propertyId },
        },
      }) => [
        closeDrawer(),
        openSnackbar({
          snackbarType: 'success',
          snackbarMessage: i18n.t('INVITE_MEMBER_SUCCESS'),
        }),
        fetchMembers({ propertyId }),
      ],
    ),
  );

export default combineEpics(inviteMemberEpic, inviteMemberSucceededEpic);
